import { apiSlice } from '../../api';
import type { GetCoinsDTO, GetCoinsResult, GetCoinsByTypeResult, GetCoinsByTypeDTO } from './types';

const coinsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getCoins: build.query<GetCoinsResult, GetCoinsDTO>({
      query: () => ({
        url: '/v1/coins',
        method: 'GET',
      }),
    }),

    getCoinsByType: build.query<GetCoinsByTypeResult, GetCoinsByTypeDTO>({
      query: ({ type }) => ({
        url: `/v1/coins/${type}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetCoinsQuery, useLazyGetCoinsQuery } = coinsEndpoints;
export const { useGetCoinsByTypeQuery } = coinsEndpoints;

export type CoinsController = typeof coinsEndpoints;
